import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  FormattedHTMLMessage,
  intlShape,
  injectIntl,
} from 'react-intl';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Sortable from 'react-sortablejs';
import ShareIcon from '@material-ui/icons/Share';
import { withCookies, Cookies } from 'react-cookie';

import * as loadingBarActions from 'react-redux-loading-bar';
import large from '../../../components/large_screen.scss';

import Link from '../../../components/Link/Link';
import CourseDetailsHeader from '../CourseDetailsHeader/CourseDetailsHeader';
import { isAdmin, isProfessionalMainGroup } from '../../../helpers';

import * as courseDetailsActions from '../../../actions/courseDetails';

import s from './CourseDetailsNotes.scss';

import messages from './courseDetailsNotesMessages';
import SkholeIcon13 from '../../../components/statelessComponents/Icons/SkholeIcon13';
import SkholeIcon36 from '../../../components/statelessComponents/Icons/SkholeIcon36';

@injectIntl
@withStyles(s)
@withStyles(large)
@withCookies
@connect(
  state => ({
    auth: state.auth,
    course: state.courseDetails.course,
    textNotes: state.courseDetails.textNotes,
    videoNotes: state.courseDetails.videoNotes,
    loadingTextNotes: state.courseDetails.loadingTextNotes,
    loadingVideoNotes: state.courseDetails.loadingVideoNotes,
    error: state.courseDetails.error,
    pubicNotesStatus: state.courseDetails.pubicNotesStatus,
    loadingPubicNotesStatus: state.courseDetails.loadingPubicNotesStatus,
    lang: state.intl.locale,
    offline: state.online.offline,
  }),
  dispatch =>
    bindActionCreators(
      {
        showLoading: loadingBarActions.showLoading,
        hideLoading: loadingBarActions.hideLoading,
        getCourseTextNotes: courseDetailsActions.getCourseTextNotes,
        getCourseVideoNotes: courseDetailsActions.getCourseVideoNotes,
        getCoursePublicNotesStatus:
          courseDetailsActions.getCoursePublicNotesStatus,
      },
      dispatch,
    ),
)
export default class CourseDetailsNotes extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired, // eslint-disable-line
    course: PropTypes.object.isRequired, // eslint-disable-line
    error: PropTypes.object, // eslint-disable-line
    textNotes: PropTypes.array.isRequired, // eslint-disable-line
    videoNotes: PropTypes.array.isRequired, // eslint-disable-line
    showLoading: PropTypes.func.isRequired,
    hideLoading: PropTypes.func.isRequired,
    loadingPubicNotesStatus: PropTypes.bool.isRequired,
    getCourseTextNotes: PropTypes.func.isRequired,
    getCourseVideoNotes: PropTypes.func.isRequired,
    getCoursePublicNotesStatus: PropTypes.func.isRequired,
    pubicNotesStatus: PropTypes.shape({
      shareNotes: PropTypes.string,
    }),
    intl: intlShape.isRequired,
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    lang: PropTypes.string.isRequired,
    offline: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    pubicNotesStatus: {
      shareNotes: 'none',
    },
  };

  static contextTypes = {
    fetch: PropTypes.func,
  };

  state = {
    textNotes: this.props.textNotes,
    videoNotes: this.props.videoNotes,
    lessonIds: _.union(
      _.map(this.props.textNotes, 'lessonId'),
      _.map(this.props.videoNotes, 'lessonId'),
    ),
    noteToRemove: {},
    isSnackBarShown: false,
    isConfirmDeleteOpen: false,
    isUpdating: false,
    isShareModalOpened: false,
    showNotes: _.get(this, 'props.pubicNotesStatus.showNotes', 'none'),
  };

  componentWillReceiveProps(nextProps) {
    if (_.get(this, 'props.course._id') !== _.get(nextProps, 'course._id')) {
      this.setState({
        textNotes: nextProps.textNotes,
        videoNotes: nextProps.videoNotes,
        lessonIds: _.union(
          _.map(nextProps.textNotes, 'lessonId'),
          _.map(nextProps.videoNotes, 'lessonId'),
        ),
      });
    }
  }

  setVideoFormat = () => {
    this.props.cookies.set(
      'contentTypeSwitchers',
      {
        video: true,
        text: true,
        audio: false,
      },
      { path: '/', domain: window.App.cookieDomain },
    );
  };

  hideSnackBar = () => {
    this.setState({
      isSnackBarShown: false,
    });
  };

  showConfirmDelete = ({ lessonId, noteId, text, type }) => {
    this.setState({
      isConfirmDeleteOpen: true,
      noteToRemove: { lessonId, noteId, text, type },
    });
  };

  closeConfirmDelete = () => {
    this.setState({
      isConfirmDeleteOpen: false,
    });
  };

  removeTextNote = () => {
    const {
      noteToRemove: { lessonId, noteId },
    } = this.state;
    // todo confirm, preloader, disable, sorting, share notes
    let { textNotes } = this.state;
    textNotes = textNotes.map(item => ({
      ...item,
      notes: _.filter(item.notes, note => note._id !== noteId),
    }));
    this.setState(
      {
        textNotes,
        isConfirmDeleteOpen: false,
      },
      () => this.updateTextNotes(lessonId),
    );
  };

  removeVideoNote = () => {
    const {
      noteToRemove: { lessonId, noteId },
    } = this.state;
    // todo confirm, preloader, disable, sorting, share notes
    let { videoNotes } = this.state;
    videoNotes = videoNotes.map(item => ({
      ...item,
      notes: _.filter(item.notes, note => note._id !== noteId),
    }));
    this.setState(
      {
        videoNotes,
        isConfirmDeleteOpen: false,
      },
      () => this.updateVideoNotes(lessonId),
    );
  };

  changeTextNotesOrder = (lessonId, order) => {
    const { textNotes } = this.state;
    const notes = _.get(_.find(textNotes, { lessonId }), 'notes', []);

    textNotes[_.findIndex(textNotes, { lessonId })].notes = _.sortBy(
      _.map(notes, item => ({
        ...item,
        order: order.indexOf(item._id),
      })),
      item => item.order,
    );

    this.setState(
      {
        textNotes,
      },
      () => this.updateTextNotes(lessonId),
    );
  };

  changeVideoNotesOrder = (lessonId, order) => {
    const { videoNotes } = this.state;
    const notes = _.get(_.find(videoNotes, { lessonId }), 'notes', []);

    videoNotes[_.findIndex(videoNotes, { lessonId })].notes = _.sortBy(
      _.map(notes, item => ({
        ...item,
        order: order.indexOf(item._id),
      })),
      item => item.order,
    );

    this.setState(
      {
        videoNotes,
      },
      () => this.updateVideoNotes(lessonId),
    );
  };

  updateTextNotes = lessonId => {
    const {
      getCourseTextNotes,
      showLoading,
      hideLoading,
      course: { _id: courseId },
    } = this.props;
    const { textNotes } = this.state;
    const highlights = _.get(_.find(textNotes, { lessonId }), 'notes', []);

    showLoading();
    this.setState({
      isUpdating: true,
    });

    return this.context
      .fetch(`/api/courses/${courseId}/text-notes/${lessonId}`, {
        method: 'PUT',
        body: JSON.stringify(highlights),
      })
      .then(res => {
        if (res.ok) {
          hideLoading();
          getCourseTextNotes(courseId);
          this.setState({
            isSnackBarShown: true,
            isUpdating: false,
          });
          // todo disable editor while loading
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isUpdating: false,
        });
      });
  };

  updateVideoNotes = lessonId => {
    const {
      getCourseVideoNotes,
      showLoading,
      hideLoading,
      course: { _id: courseId },
    } = this.props;
    const { videoNotes } = this.state;
    const notes = _.get(_.find(videoNotes, { lessonId }), 'notes', []);

    showLoading();
    this.setState({
      isUpdating: true,
    });

    return this.context
      .fetch(`/api/courses/${courseId}/video-notes/${lessonId}`, {
        method: 'PUT',
        body: JSON.stringify(notes),
      })
      .then(res => {
        if (res.ok) {
          hideLoading();
          getCourseVideoNotes(courseId);
          this.setState({
            isSnackBarShown: true,
            isUpdating: false,
          });
          // todo disable editor while loading
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isUpdating: false,
        });
      });
  };

  openShareModal = () => {
    this.setState({
      isShareModalOpened: true,
    });
  };

  closeShareModal = () => {
    this.setState({
      isShareModalOpened: false,
      showNotes: _.get(this, 'props.pubicNotesStatus.showNotes', 'none'),
    });
  };

  handleChangeShowNotes = (event, showNotes) => {
    this.setState({ showNotes });
  };

  shareNotes = () => {
    const { showNotes } = this.state;
    const {
      course: { _id },
      getCoursePublicNotesStatus,
    } = this.props;

    this.setState({
      isSharingNotes: false,
    });

    return this.context
      .fetch(`/api/courses/${_id}/share-notes`, {
        method: 'PUT',
        body: JSON.stringify({ showNotes }),
      })
      .then(res => {
        if (res.ok) {
          this.setState({
            isSharingNotes: false,
            isShareModalOpened: false,
          });
          getCoursePublicNotesStatus(_id);
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({
          isSharingNotes: false,
        });
      });
  };

  render() {
    const {
      course,
      error,
      pubicNotesStatus,
      loadingPubicNotesStatus,
      intl: { formatMessage },
      auth,
      offline,
    } = this.props;
    const {
      textNotes,
      videoNotes,
      isSnackBarShown,
      noteToRemove,
      isConfirmDeleteOpen,
      isUpdating,
      lessonIds,
      isShareModalOpened,
      showNotes,
      isSharingNotes,
    } = this.state;

    const shareNotesOptions = [
      {
        value: 'none',
        label: <FormattedMessage {...messages.notesOptionsNoneLabel} />,
        description: (
          <FormattedMessage {...messages.notesOptionsNoneDescription} />
        ),
      },
      {
        value: 'teachers',
        label: (
          <FormattedMessage
            {...(isProfessionalMainGroup(auth)
              ? messages.notesOptionsTeachersAndGroupLeaderLabelProfessional
              : messages.notesOptionsTeachersAndGroupLeaderLabel)}
          />
        ),
        description: (
          <FormattedMessage
            {...(isProfessionalMainGroup(auth)
              ? messages.notesOptionsTeachersDescriptionProfessional
              : messages.notesOptionsTeachersDescription)}
          />
        ),
      },
      // {
      //   value: 'group',
      //   label: <FormattedMessage {...messages.notesOptionsGroupLabel} />,
      //   description: (
      //     <FormattedMessage {...messages.notesOptionsGroupDescription} />
      //   ),
      // },
    ];

    const lessons = _((course && course.sections) || [])
      .map('items')
      .flatten()
      .filter(item => item.itemType === 'Lesson')
      .map('item')
      .value();

    const renderLesson = lessonId => {
      const lesson = _.find(lessons, { _id: lessonId });

      if (!lesson) {
        return (
          <Typography key={lessonId} className={s.lessonName}>
            {lessonId}
          </Typography>
        );
      }

      return (
        <Link
          key={lessonId}
          to={`/courses/${course.slug}/lessons/${_.get(lesson, 'slug')}`}
          className={classNames(s.lessonName, s.noneTextDecoration)}
        >
          <Typography className={s.lessonName}>
            {_.get(lesson, 'name')}
          </Typography>
        </Link>
      );
    };

    const renderLessonNotes = ({ notes, lessonId, type }) =>
      _(notes)
        .map(note => {
          const lesson = _.find(lessons, { _id: lessonId });
          let listItemProps = {};
          if (lesson && type === 'text') {
            listItemProps = {
              component: Link,
              to: `/courses/${course.slug}/lessons/${_.get(lesson, 'slug')}`,
            };
          }
          if (lesson && type === 'video') {
            listItemProps = {
              component: Link,
              onClick: this.setVideoFormat,
              to: `/courses/${course.slug}/lessons/${_.get(
                lesson,
                'slug',
              )}?videoNoteId=${note._id}`,
            };
          }
          return (
            <ListItem
              className={s.notesListItem}
              key={note._id}
              ContainerComponent="div"
              ContainerProps={{
                'data-id': note._id,
              }}
              button
              {...listItemProps}
            >
              <ListItemIcon>
                <IconButton
                  disabled={offline}
                  className={classNames('note-change-order', s.reorder)}
                >
                  <SkholeIcon36 className={s.reorderIcon} />
                </IconButton>
              </ListItemIcon>
              <ListItemText
                primary={note.text}
                classes={{
                  root: s.noteTitleTextWrapper,
                  primary: s.noteTitleTextPrimary,
                  secondary: s.noteTitleTextSecondary,
                }}
              />
              {!offline && (
                <ListItemSecondaryAction>
                  <Tooltip title={formatMessage(messages.removeTooltipTitle)}>
                    <IconButton
                      data-test-id="p8_Le2ZGUp8U1Uvy0QWO2"
                      onClick={() =>
                        this.showConfirmDelete({
                          lessonId,
                          type,
                          noteId: note._id,
                          text: note.text,
                        })
                      }
                    >
                      <SkholeIcon13 className={s.removeIcon} />
                    </IconButton>
                  </Tooltip>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          );
        })
        .value();

    if (error) {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.loadingWrapper}>
              <Typography gutterBottom color="error">
                {error.error}
              </Typography>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={s.root}>
        <div className={s.container}>
          <CourseDetailsHeader />
          <div
            className={classNames(s.shareNotesWrapper, large.generalSection)}
          >
            {!isAdmin(auth) && (
              <div className={s.buttonWrapper}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.openShareModal}
                  disabled // ={loadingPubicNotesStatus}
                >
                  <ShareIcon className={s.shareIcon} />
                  {!['group', 'teachers'].includes(
                    _.get(pubicNotesStatus, 'showNotes', []),
                  ) && formatMessage(messages.shareLabel)}
                  {_.get(pubicNotesStatus, 'showNotes') === 'group' &&
                    formatMessage(messages.sharedForGroupLabel)}
                  {_.get(pubicNotesStatus, 'showNotes') === 'teachers' &&
                    formatMessage(messages.sharedForTeachersLabel)}
                  {loadingPubicNotesStatus && (
                    <CircularProgress size={24} className={s.buttonProgress} />
                  )}
                </Button>
              </div>
            )}
          </div>
          <div
            className={classNames(
              s.notesBlock,
              isUpdating ? s.disabled : undefined,
              large.generalSection,
            )}
          >
            {_.map(lessonIds, (lessonId, index) => {
              const lessonTextNotes = _.get(
                _.find(textNotes, { lessonId }),
                'notes',
                [],
              );
              const lessonVideoNotes = _.get(
                _.find(videoNotes, { lessonId }),
                'notes',
                [],
              );

              if (!lessonTextNotes.length && !lessonVideoNotes.length) {
                return null;
              }

              const contentToRender = [renderLesson(lessonId, index)];

              if (lessonTextNotes.length) {
                contentToRender.push(
                  <List
                    component="div"
                    key={`${lessonId}_text`}
                    subheader={
                      <ListSubheader component="div" disableSticky>
                        <FormattedMessage {...messages.textNotesLabel} />
                      </ListSubheader>
                    }
                    disablePadding
                  >
                    <Sortable
                      options={{
                        handle: '.note-change-order',
                      }}
                      onChange={order =>
                        this.changeTextNotesOrder(lessonId, order)
                      }
                    >
                      {renderLessonNotes({
                        notes: lessonTextNotes,
                        type: 'text',
                        lessonId,
                      })}
                    </Sortable>
                  </List>,
                );
              }

              if (lessonVideoNotes.length) {
                contentToRender.push(
                  <List
                    component="div"
                    key={`${lessonId}_video`}
                    subheader={
                      <ListSubheader component="div" disableSticky>
                        <FormattedMessage {...messages.videoNotesLabel} />
                      </ListSubheader>
                    }
                    disablePadding
                  >
                    <Sortable
                      options={{
                        handle: '.note-change-order',
                      }}
                      onChange={order =>
                        this.changeVideoNotesOrder(lessonId, order)
                      }
                    >
                      {renderLessonNotes({
                        notes: lessonVideoNotes,
                        type: 'video',
                        lessonId,
                      })}
                    </Sortable>
                  </List>,
                );
              }

              return (
                <div key={lessonId} className={s.noteBlock}>
                  {contentToRender}
                </div>
              );
            })}
          </div>
          <Dialog open={isConfirmDeleteOpen} onClose={this.closeConfirmDelete}>
            <DialogTitle>
              <FormattedMessage {...messages.wantToDeleteTitle} />
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <FormattedHTMLMessage
                  {...messages.noteWillBeRemovedMsg}
                  values={{ text: noteToRemove.text }}
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                data-test-id="bHtPwOy5yz8KrZXDu6k91"
                onClick={this.closeConfirmDelete}
                color="primary"
              >
                <FormattedMessage {...messages.refuseDeleteBtnLabel} />
              </Button>
              <div className={s.buttonWrapper}>
                <Button
                  data-test-id="IkD0N1gh_ObwYgDFCCLvs"
                  onClick={() =>
                    noteToRemove.type === 'video'
                      ? this.removeVideoNote()
                      : this.removeTextNote()
                  }
                  color="primary"
                  autoFocus
                >
                  <FormattedMessage {...messages.deleteBtnLabel} />
                </Button>
              </div>
            </DialogActions>
          </Dialog>
          <Dialog
            open={isShareModalOpened}
            onClose={this.closeShareModal}
            classes={{
              paperWidthSm: s.sharedDialog,
            }}
          >
            <DialogTitle>
              <FormattedMessage {...messages.shareNotesDialogTitle} />
            </DialogTitle>
            <DialogContent>
              <RadioGroup
                name="shareNotes"
                value={showNotes}
                onChange={this.handleChangeShowNotes}
              >
                {shareNotesOptions.map(({ value, label, description }) => (
                  <FormControlLabel
                    value={value}
                    key={value}
                    control={<Radio color="primary" />}
                    label={
                      <span>
                        <span>{label}</span>
                        <br />
                        <span className={s.shareNoteOptionDescription}>
                          {description}
                        </span>
                      </span>
                    }
                  />
                ))}
              </RadioGroup>
            </DialogContent>
            <DialogActions>
              <Button
                data-test-id="8EtjpdfIFtGPM5JFx3N1b"
                color="primary"
                onClick={this.closeShareModal}
              >
                <FormattedMessage {...messages.refuseDeleteBtnLabel} />
              </Button>
              <Button
                data-test-id="IIBc08ixT2FC9HRMIoWrN"
                color="primary"
                onClick={this.shareNotes}
                disabled={isSharingNotes}
                autoFocus
              >
                <FormattedMessage {...messages.submitBtnLabel} />
                {isSharingNotes && (
                  <CircularProgress size={24} className={s.buttonProgress} />
                )}
              </Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            open={isSnackBarShown}
            onClose={this.hideSnackBar}
            autoHideDuration={2000}
            message={formatMessage(messages.notesSnackbarMsg)}
          />
        </div>
      </div>
    );
  }
}
